/** Lowercase and strip accents/diacritics so "LEGa" matches "LEĜA". */
export function normalizeForSearch(value: string): string {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function textMatchesSearchQuery(text: string, query: string): boolean {
  const normalizedQuery = normalizeForSearch(query);
  if (!normalizedQuery) {
    return true;
  }
  return normalizeForSearch(text).includes(normalizedQuery);
}
